import { IUser } from "../types/user.interface";
import { Authority } from "../types/user.type";
import { IAuthUser } from "../auth/types/auth.interface";

class BaseUser {
  authority: Authority;
  email: string;
  phone_number: string;
  first_name: string;
  last_name: string;
  reseller: string;
  finished_projects: number;
  pending_projects: number;

  constructor(payload: IAuthUser | IUser) {
    this.authority = payload.authority;
    this.reseller = payload.reseller;
    this.first_name = payload.first_name;
    this.last_name = payload.last_name;
    this.phone_number = payload.phone_number;
    this.email = payload.email;
    this.pending_projects = payload.pending_projects;
    this.finished_projects = payload.finished_projects;
  }

  get name(): string {
    return `${this.first_name} ${this.last_name}`;
  }
}

export class User extends BaseUser implements IUser {
  _id: string;
  last_seen: string;

  constructor(payload: IUser) {
    super(payload);
    this._id = payload._id;
    this.last_seen = payload.last_seen;
  }
}

export class AuthUser extends BaseUser implements IAuthUser {}
